import React from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { useHistory } from 'react-router-dom'
import { useRecoilValue } from 'recoil'

import {
  Button,
  BUTTON_VARIANT_PRIMARY,
  BUTTON_VARIANT_SECONDARY,
  Flex,
  FlexItem
} from 'mailup-web-components'

import useMessageEditAction from 'Hooks/useMessageEditAction'
import useMessageSendAction from 'Hooks/useMessageSendAction'

import { messageDetailsState, canSendState } from 'Hooks/useMessageDetails'

const Footer = ({ idMessage }) => {
  const intl = useIntl()
  const history = useHistory()
  const { isBee, messageType } = useRecoilValue(messageDetailsState(idMessage))

  const canSend = useRecoilValue(canSendState(idMessage))

  const handleEditClick = useMessageEditAction(idMessage, isBee, messageType)
  const handleSendClick = useMessageSendAction(idMessage)

  const handleOverviewClick = () => {
    const route = `/messages/email/${idMessage}/overview?source=EmailMessages&op=mod`
    history.push(route)
  }

  return (
    <Flex alignItems='center' justifyContent='flex-end' columnGap='8px'>
      <FlexItem>
        <Button
          kind={BUTTON_VARIANT_SECONDARY}
          data-mu-test='message-footer__overview'
          onClick={handleOverviewClick}
        >
          {intl.formatMessage({ id: 'Load.MailupCommon.Overview' })}
        </Button>
      </FlexItem>

      {canSend && (
        <>
          <FlexItem>
            <Button
              kind={BUTTON_VARIANT_SECONDARY}
              data-mu-test='message-footer__edit'
              onClick={handleEditClick}
            >
              {intl.formatMessage({ id: 'Load.MailupCommon.Edit' })}
            </Button>
          </FlexItem>
          <FlexItem>
            <Button
              kind={BUTTON_VARIANT_PRIMARY}
              data-mu-test='message-footer__send'
              onClick={handleSendClick}
            >
              {intl.formatMessage({ id: 'Load.MailupCommon.Send' })}
            </Button>
          </FlexItem>
        </>
      )}
    </Flex>
  )
}

Footer.propTypes = {
  idMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired
}

export default Footer
